import { observer } from "mobx-react-lite";
import { Box, Button, Center, FlexProps } from "@chakra-ui/react";

import { IPathOptions, Lang } from "@noli/core";
import {
  BoardStore,
  langStore,
  translate,
  toolbarStore,
  undoBrush,
  redoBrush,
  updateBrushOptions,
  toMultipleBrush,
} from "@noli/business";

import { PathEditorPanel } from "./common";
import { statusStore, switchNormalBrushMode } from "@/stores/status";
import SubEditorPanel from "@/components/SubPanel/SubEditor";
import { Editor_Words } from "@/utils/lang/editor";

function SingleNormalBrushEditor({
  alias,
  lang,
  noTitle,
  pathIndex,
  options,
  ...others
}: FlexProps & {
  alias: string;
  lang: Lang;
  noTitle?: boolean;
  pathIndex?: number;
  options: IPathOptions;
}) {
  const brushManager = BoardStore.board.brushPluginNullable;
  if (!brushManager) {
    return null;
  }
  const { fill, stroke, width, linecap } = options;

  const setOpt = (opt: Partial<IPathOptions>) => {
    updateBrushOptions({ fill, stroke, width, linecap, ...opt, index: pathIndex });
  };

  const handleColorChange = (color: string) => {
    setOpt({ stroke: color, fill: color });
  };

  // setWidth={() => (width) => setOpt({ width })}
  // setUseFill={(use) => setOpt({ fill: use ? stroke : "none" })}
  // setFill={() => (fill) => setOpt({ fill })}
  return (
    <PathEditorPanel
      alias={alias}
      {...others}
      lang={lang}
      noTitle={noTitle}
      options={options}
      setStroke={() => (stroke) => handleColorChange(stroke)}
    />
  );
}

function NormalBrushEditor(props: FlexProps) {
  const lang = langStore.tgt;
  const options = toolbarStore.allBrushOptions;
  const brushManager = BoardStore.board.brushPluginNullable;
  const inNormalBrushMode = statusStore.inNormalBrushMode;
  if (!inNormalBrushMode || !options || !brushManager) {
    return null;
  }

  let Core;
  if (!Array.isArray(options)) {
    Core = (
      <SingleNormalBrushEditor alias=".normal.brush." {...props} lang={lang} options={options} />
    );
  } else {
    Core = options.map((opt, i) => (
      <SingleNormalBrushEditor
        alias={`.normal.brush.${i}.`}
        {...props}
        key={i}
        lang={lang}
        noTitle={i !== 0}
        pathIndex={i}
        options={opt}
      />
    ));
  }

  return (
    <SubEditorPanel w="100%" pb="32px">
      {Core}
      <Center mt="16px">
        <Button w="37.5%" onClick={undoBrush} disabled={toolbarStore.numBrushPaths === 0}>
          {translate("undo-brush", lang)}
        </Button>
        <Box w="5%" />
        <Button w="37.5%" onClick={redoBrush} disabled={toolbarStore.numBrushHistory === 0}>
          {translate("redo-brush", lang)}
        </Button>
      </Center>
      {/* {Array.isArray(options) ? null : (
        <Center mt="16px">
          <Button w="80%" onClick={toMultipleBrush}>
            {translate("to-multiple-brush", lang)}
          </Button>
        </Center>
      )} */}
      <Center mt="16px">
        <Button w="80%" onClick={switchNormalBrushMode}>
          {translate(Editor_Words["end-brush"], lang)}
        </Button>
      </Center>
    </SubEditorPanel>
  );
}

export default observer(NormalBrushEditor);
